import React from "react";
import * as moment from "moment";
import NotificationService from "services/NotificationService";
import classNames from "classnames";
import { useNotificationsContext } from "store/contexts/notificationContext";
import { useHistory } from "react-router-dom";
import UserDefaultAvatar from "assets/img/user.svg";
import Avatar from "components/Avatar";

export default ({ notification }) => {
  const history = useHistory();
  const { readNotification, closeNotificationBar } = useNotificationsContext();

  if (notification.type === "team.post.buzz") {
    let x = notification.data.message;
    x = x.replace("buzzed", "reacted");
    notification.data.message = x;
  }
  if (notification.type === "team.post.expression") {
    let x = notification.data.message;
    x = x.replace("expressed", "engaged");
    notification.data.message = x;
  }

  const handleNotification = async () => {
    try {
      readNotification({
        ...notification,
        read_at: true,
      });

      await NotificationService.getReadNotification(notification.id);
    } catch (e) {
      console.log(e);
    }

    closeNotificationBar();

    if (notification.type === "course.created" || notification.type === "course.shared") {
      if (notification.data.course_id && notification.data.team_id) {
        history.push({
          pathname: `/teams/${notification.data.team_id}/courses/${notification.data.course_id}/view`,
        });
      }
      return;
    }

    if (notification.type === "course.completed") {
      if (notification.data.course_id && notification.data.team_id) {
        history.push({
          pathname: `/teams/${notification.data.team_id}/growth-partner-courses/${notification.data.course_id}/view`,
        });
      }
      return;
    }

    if (notification.type === "team.trivia") {
      history.push({
        pathname: `/teams/${notification.data.team_id}/wellness/focus-boosters/single-trivia/${notification.data.trivia_id}`,
      });
      
      return;
    }

    if (notification.type === "company.post.rating") {
      history.push({
        pathname: `/company/${notification.data.company_id}/post/${notification.data.post_id}`,
        search: `?user_rating=${notification.data.user_rating}`,
      });
      
      return;
    }

    if (
      notification.data.company_id &&
      notification.data.parent_expression_id
    ) {
      history.push({
        pathname: `/company/${notification.data.company_id}/post/${notification.data.post_id}`,
        search: `?expression_id=${notification.data.parent_expression_id}&reply_id=${notification.data.expression_id}`,
      });

      return;
    }

    if (notification.data.company_id) {
      history.push({
        pathname: `/company/${notification.data.company_id}/post/${notification.data.post_id}`,
        search: `?expression_id=${notification.data.expression_id}`,
      });

      return;
    }

    if (notification.type === "user.privatechat.ping") {
      window.matchMedia("(max-width: 991px)").matches
        ? history.push({
            pathname: `/private-chat/${notification.data.user_id}/chat`,
          })
        : history.push({
            pathname: `/chat`,
            userData: {
              user_id: notification.data.user_id,
              team_id: notification.data.team_id,
            },
          });

      return;
    }

    if (notification.data.todo_list_item_id) {
      history.push({
        pathname: `/teams/${notification.data.team_id}/todo-list/${notification.data.todo_list_id}/todo-list-item/${notification.data.todo_list_item_id}`,
        search: !notification.data.parent_expression_id
          ? `?expression_id=${notification.data.expression_id}`
          : `?expression_id=${notification.data.parent_expression_id}&reply_id=${notification.data.expression_id}`,
      });
      return;
    }

    if (notification.data.poll_id) {
      history.push({
        pathname: `/teams/${notification.data.team_id}/poll/${notification.data.poll_id}/detail`,
        state: { status: true },
      });
      return;
    }

    if (
      ["team.invitation.accept", "team.invitation.reject"].includes(
        notification.type
      )
    ) {
      history.push({
        pathname: `/teams/${notification.team_id}/info`,
      });
      return;
    }

    if (notification.data.todo_list_id) {
      history.push(
        `/teams/${notification.data.team_id}/todo-list/${notification.data.todo_list_id}`
      );
      return;
    }

    if (notification.data.parent_expression_id) {
      history.push({
        pathname: `/teams/${notification.data.team_id}/post/${notification.data.post_id}`,
        search: `?expression_id=${notification.data.parent_expression_id}&reply_id=${notification.data.expression_id}`,
      });

      return;
    }

    if (
      ["team.survey.ended", "team.survey.created"].includes(notification.type)
    ) {
      history.push(
        `/teams/${notification.data.team_id}/wellness/survey/manage`
      );
      return;
    }

    if (notification.type === "team.survey.shared") {
      const surveyId = notification.data.survey_id;
      if (surveyId) {
        history.push(
          `/teams/${notification.data.team_id}/wellness/survey?surveyId=${surveyId}`
        );
      } else {
        history.push(
          `/teams/${notification.data.team_id}/wellness/survey`
        );
      }
      return;
    }

    if (
      [
        "mindfullness.company_culture.shared",
        "mindfullness.company_culture.created",
      ].includes(notification.type)
    ) {
      history.push(
        `/teams/${notification.data.team_id}/training-videos?tab=cc`
      );
      return;
    }

    history.push({
      pathname: `/teams/${notification.data.team_id}/post/${notification.data.post_id}`,
      search: `?expression_id=${notification.data.expression_id}`,
    });
  };

  return (
    <div
      key={notification?.data?.id}
      className={classNames({
        "notification-box team-notification f-left mb-2": true,
        readNotification: notification.read_at ? true : false,
        newNotificationBackground: !notification.read_at ? true : false,
      })}
      onClick={handleNotification}
    >
      <div className="img_user">
        <Avatar
          className="mw-40 userNotificationImage"
          src={notification?.data.avatar ?? UserDefaultAvatar}
          alt={"avatar"}
        />
      </div>
      <div className="notification-data">
        <div className="notification-text">{notification?.data.message} </div>
        <span className="n-team-name fw-600">
          {notification?.data.team_name ?? notification?.data?.company_name}
        </span>
        <small className="post_time color-light">
          {moment(notification?.created_at).fromNow()}
        </small>
      </div>
    </div>
  );
};
